export default {
  admin: {
    pageTitle: "Администрирование",
    pageSubtitle: "Управление ролевой моделью: роли, права и пользователи.",
    badge: "Администратор",
    unnamed: "администратор",
    sidebarAria: "Боковая панель администрирования",
    navAria: "Разделы администрирования",
    associationsNavGroupLabel: "Объединения и союзы",
    usersAndRolesNavGroupLabel: "Пользователи и роли",
    creativeSelfDefinitionNavGroupLabel: "Самоопределение",
    logsNavGroupLabel: "Логи и аудит",
    logout: "Выйти",
    loadError: "Не удалось загрузить данные. Попробуйте позже.",
    saving: "Сохраняем…",
    save: "Сохранить",
    edit: "Редактировать",
    delete: "Удалить",
    cancel: "Отмена",
    found: "Найдено: {{count}}",
    shownOf: "Показано {{shown}} из {{total}}",
    nav: {
      overview: "Обзор",
      users: "Пользователи",
      roles: "Роли",
      creativeRolesCatalog: "Каталог ролей",
      creativeRolesModeration: "Модерация новых ролей",
      groupKinds: "Виды групп",
      groupsTree: "Дерево ассоциаций",
      unverifiedMemberships: "Очередь заявок",
      applicationLogs: "Логи приложения",
      businessAudit: "Бизнес-аудит",
      auditEvents: "Аудит мероприятий",
      auditDeposits: "Аудит депонирований",
      auditAssociationMemberships: "Аудит членства в союзах",
    },
    sectionSubtitle: {
      users: "Управление учётными записями и их ролями",
      roles: "Управление ролями и правами доступа",
      creativeRolesCatalog: "Управление ролями самоопределения",
      creativeRolesModeration: "Модерация предложений новых ролей от пользователей",
      groupKinds: "Справочник видов объединений (Союз, Сообщество…)",
      groupsTree: "Иерархия индустрий, союзов и отделений",
      unverifiedMemberships: "Заявки на членство, ожидающие подтверждения",
      applicationLogs: "Хвост суточного текстового лог-файла Serilog для этого инстанса API",
      businessAudit: "История статусов и действий по идентификатору сущности (депозит, мероприятие, регистрация, членство)",
      auditEvents: "История статусов и действий по мероприятию (включая связанные регистрации)",
      auditDeposits:
        "Поиск депозита по GUID, сертификату, авторам или правообладателям и история статусов по выбранной записи",
      auditAssociationMemberships: "История статусов и действий по идентификатору членства в союзе",
    },
    creativeSelfDefinition: {
      suggestionsSectionTitle: "Предложения новых типовых ролей",
      loadError: "Не удалось загрузить список предложений",
      noAccess: "Недостаточно прав для модерации самоопределения",
      actionError: "Не удалось выполнить действие",
      refresh: "Обновить список",
      empty: "Нет предложений ролей",
      colAuthor: "Автор",
      colDirection: "Направление",
      colSub: "Поднаправление",
      colProposal: "Предложение",
      colProposedDescription: "Описание в предложении",
      colStatus: "Статус",
      colActions: "Действия",
      approve: "Одобрить",
      approveTitle: "Одобрить предложение роли",
      approveCatalogDescription: "Описание для типовой роли в каталоге (необязательно)",
      approveCatalogDescriptionPlaceholder:
        "Если не заполнить, будет использовано описание из предложения или значение по умолчанию на стороне сервера.",
      approveConfirm: "Одобрить",
      reject: "Отклонить",
      rejectTitle: "Отклонить предложение",
      rejectComment: "Комментарий модератора (необязательно)",
      rejectConfirm: "Отклонить",
      status: {
        pending: "На проверке",
        approved: "Одобрено",
        rejected: "Отклонено",
      },
      catalog: {
        title: "Каталог типовых ролей",
        lead: "Создание ролей в поднаправлениях, правка описания и удаление.",
        refresh: "Обновить список",
        loadError: "Не удалось загрузить таксономию",
        actionError: "Не удалось выполнить действие",
        empty: "В таксономии пока нет типовых ролей",
        colName: "Роль",
        colDescription: "Описание",
        create: "Добавить роль",
        createTitle: "Новая типовая роль",
        createSubmit: "Создать",
        createValidation: "Укажите поднаправление и название роли",
        subDirectionsMultiLabel: "Поднаправления (одно или несколько)",
        subDirectionsHint: "Типовая роль появится в каждом выбранном поднаправлении.",
        createSubDirectionsRequired: "Выберите хотя бы одно поднаправление.",
        createNameRequired: "Укажите название роли.",
        emptySubDirections: "В таксономии для этого направления нет поднаправлений.",
        nameLabel: "Название",
        descriptionLabel: "Описание",
        maxChars: "Не более {{max}} символов.",
        editTitle: "Изменить описание роли",
        deleteTitle: "Удалить типовую роль?",
        deleteLead: "Роль будет скрыта из каталога (мягкое удаление). Пользователи не смогут выбрать её в новых профилях.",
        deleteConfirm: "Удалить из каталога",
      },
    },
    applicationLogs: {
      disclaimerTitle: "Перед просмотром логов",
      disclaimerK8s:
        "В Kubernetes или при нескольких репликах запросы могут попадать на разные поды. В ответе видны только логи того инстанса, который обслужил запрос. Для сводки по кластеру используйте stdout и системы вроде Loki или ELK.",
      disclaimerPii:
        "В логах теоретически может быть персональные данные или секреты. Право на просмотр логов выдают узкому кругу лиц (настраивается в управлении правами).",
      disclaimerRotation:
        "В списке только суточные ротированные файлы log-ГГГГММДД.txt. Старый неротированный logs.txt в список не входит.",
      emptyDates: "Нет доступных суточных лог-файлов (или каталог пуст).",
      dateLabel: "Дата лога",
      maxBytesLabel: "Макс. байт с конца",
      maxLinesLabel: "Макс. строк с конца",
      refresh: "Обновить",
      loadingLog: "Загрузка лога…",
      emptyLog: "(пустой хвост при текущих настройках)",
      loadDatesError: "Не удалось загрузить список дат логов.",
      loadLogError: "Не удалось загрузить лог. Повторите попытку или измените параметры.",
      validation: {
        bytesRequired: "Укажите целое число байт с конца файла.",
        bytesRange: "Число байт с конца должно быть от {{min}} до {{max}}.",
        linesRequired: "Укажите целое число строк с конца.",
        linesRange: "Число строк с конца должно быть от {{min}} до {{max}}.",
      },
      errors: {
        fileNotFound:
          "За эту дату нет ротированного лога на этом инстансе. Выберите другую дату или другой под.",
        invalidReadParameters: "Параметры чтения вне допустимого диапазона.",
      },
    },
    businessAudit: {
      intro: "",
      entityKindLabel: "Тип сущности",
      entityIdLabel: "Идентификатор (GUID)",
      entityIdPlaceholder: "00000000-0000-0000-0000-000000000000",
      eventSearchLabel: "Мероприятие",
      eventSearchPlaceholder: "Начните вводить название…",
      eventSearchClearAria: "Очистить поле",
      openEvent: "Открыть мероприятие",
      openEventAria: "Открыть карточку мероприятия «{{title}}» в новой вкладке",
      eventSearchError: "Не удалось найти мероприятия. Попробуйте позже.",
      depositSearchLabel: "Поиск депозита",
      depositSearchPlaceholder: "GUID, номер сертификата, автор или правообладатель…",
      depositSearchClearAria: "Очистить поле поиска",
      depositSearchError: "Не удалось выполнить поиск. Попробуйте позже.",
      depositSearchResultsHeading: "Результаты поиска",
      depositSearchEmptyFilter: "Введите запрос, чтобы найти депозит (пустой запрос не показывает все записи).",
      depositSearchNoResults: "Ничего не найдено.",
      depositSearchColTitle: "Название",
      depositSearchColCertificate: "Номер сертификата",
      depositSearchColStatus: "Статус",
      depositSearchColSubmittedAt: "Дата подачи",
      depositSearchPaginationAria: "Пагинация результатов поиска",
      depositSearchRowOpenAria: "Открыть аудит депозита: {{title}}",
      load: "Загрузить",
      loading: "Загрузка записей аудита…",
      found: "Всего записей: {{count}}",
      empty: "Записей нет.",
      colWhen: "Когда",
      colEntityType: "Тип объекта",
      colParticipant: "Участник",
      colActor: "Кто",
      colAction: "Действие",
      colStatus: "Статус",
      colReason: "Причина / комментарий",
      paginationAria: "Пагинация аудита",
      validation: {
        invalidUuid: "Введите корректный GUID (формат UUID).",
        noPermissionForKind: "Недостаточно прав для выбранного типа сущности.",
      },
      errors: {
        forbidden: "Недостаточно прав для просмотра аудита этой сущности.",
        notFound: "Сущность не найдена или недоступна.",
        generic: "Не удалось загрузить аудит. Попробуйте позже.",
      },
      kind: {
        deposit: "Депозит",
        event: "Мероприятие",
        eventRegistration: "Регистрация на мероприятие",
        associationMembership: "Членство в союзе",
      },
      entityTypeLabel: {
        Deposit: "Депозит",
        Event: "Мероприятие",
        EventRegistration: "Регистрация",
        AssociationMembership: "Членство",
      },
      sortByTimeLabel: "Сортировка по времени",
      sortNewestFirst: "Сначала новые",
      sortOldestFirst: "Сначала старые",
      filtersSection: "Фильтры",
      filters: {
        entityType: "Тип",
        allEntityTypes: "Все",
        participant: "Участник (имя/логин)",
        actor: "Кто (имя/логин)",
        fromOccurredAt: "С (дата и время)",
        toOccurredAt: "По (дата и время)",
        datePlaceholder: "Выберите дату",
        timePlaceholder: "Время",
        calendarFromAria: "Календарь: дата и время с",
        calendarToAria: "Календарь: дата и время по",
        timeFromAria: "Время: с",
        timeToAria: "Время: по",
        expand: "Показать",
        collapse: "Свернуть",
        apply: "Применить",
        reset: "Сбросить",
      },
    },
    overview: {
      welcome: "Здравствуйте, {{name}}",
      welcomeHint:
        "Это кабинет администратора. Управляйте ролевой моделью — создавайте роли, назначайте права и управляйте пользователями.",
      servicesTitle: "Разделы администрирования",
      sectionHintUsersRoles: "Учётные записи, роли и права доступа",
      sectionHintAssociations: "Виды объединений, дерево союзов и заявки на членство",
      sectionHintCreativeSelfDefinition: "Модерация предложений ролей в таксономии самоопределения",
      sectionHintLogs: "Логи приложения и бизнес-аудит по сущностям",
      statsTitle: "Сводка",
      statsSubtitle: "Ключевые показатели по доступным разделам администрирования",
      statsLoading: "Загружаем сводку…",
      statsLoadError: "Не удалось загрузить сводку. Попробуйте позже.",
      retry: "Повторить загрузку сводки",
      goToSection: "Перейти в раздел",
      usersTotal: "Пользователей: {{count}}",
      rolesTotal: "Ролей: {{count}}",
      usersAndRolesChipLabel: "Пользователи и роли: {{count}}",
      usersAndRolesChipExpand: "{{label}}. Развернуть статистику",
      usersAndRolesChipCollapse: "{{label}}. Свернуть статистику",
      creativeSelfDefinitionChipLabel: "Самоопределение: {{count}}",
      creativeSelfDefinitionChipExpand: "{{label}}. Развернуть статистику",
      creativeSelfDefinitionChipCollapse: "{{label}}. Свернуть статистику",
      associationsChipLabel: "Объединения: {{count}}",
      associationsChipExpand: "{{label}}. Развернуть статистику",
      associationsChipCollapse: "{{label}}. Свернуть статистику",
      metrics: {
        users: "Пользователей",
        roles: "Ролей",
        catalogRoles: "Ролей в каталоге",
        pendingSuggestions: "На модерации",
        unverifiedMemberships: "Заявок в очереди",
        openSection: "Перейти в раздел: {{label}}, {{count}}",
      },
      pendingSuggestions: "На модерации: {{count}}",
      noPendingSuggestions: "Нет предложений на модерации",
      catalogRolesTotal: "Ролей в каталоге: {{count}}",
      unverifiedMemberships: "Заявок в очереди: {{count}}",
      logsHint: "Просмотр логов приложения и бизнес-аудита по сущностям",
      tabBadgeAria: "{{count}} в очереди",
    },
    roles: {
      add: "Добавить роль",
      searchPlaceholder: "Поиск по названию роли…",
      paginationAria: "Пагинация ролей",
      colName: "Название роли",
      colDefault: "По умолчанию",
      colPublic: "Публичная",
      colActions: "Действия",
      permissions: "Права",
      staticBadge: "Системная",
      empty: "Роли не найдены",
      loadError: "Не удалось загрузить список ролей",
      saveError: "Не удалось сохранить роль",
      deleteError: "Не удалось удалить роль",
      deleteTitle: "Удалить роль?",
      deleteMessage: "Роль «{{name}}» будет удалена. Это действие нельзя отменить.",
    },
    roleForm: {
      createTitle: "Новая роль",
      editTitle: "Редактирование роли",
      name: "Название роли",
      namePlaceholder: "Введите название",
      nameRequired: "Укажите название роли",
      isDefault: "Роль по умолчанию",
      isDefaultHint: "Будет автоматически назначаться новым пользователям",
      isPublic: "Публичная роль",
      isPublicHint: "Видна другим пользователям системы",
    },
    users: {
      searchPlaceholder: "Поиск по email, имени, фамилии или телефону…",
      paginationAria: "Пагинация пользователей",
      colEmail: "Email",
      colName: "Имя",
      colSurname: "Фамилия",
      colPhone: "Телефон",
      colStatus: "Статус",
      colActions: "Действия",
      roles: "Роли",
      active: "Активен",
      inactive: "Отключён",
      emailConfirmed: "Email подтверждён",
      empty: "Пользователи не найдены",
      loadError: "Не удалось загрузить список пользователей",
      deleteError: "Не удалось удалить пользователя",
      deleteTitle: "Удалить пользователя?",
      deleteMessage: "Пользователь {{email}} будет удалён. Это действие нельзя отменить.",
    },
    userRoles: {
      title: "Роли пользователя",
      searchPlaceholder: "Поиск по названию роли…",
      empty: "Роли не найдены",
      selectedBadge: "Выбрана",
      loadError: "Не удалось загрузить роли пользователя",
      saveError: "Не удалось сохранить роли пользователя",
    },
    permissions: {
      title: "Права доступа",
      subtitle: "Роль: {{role}}",
      empty: "Нет доступных прав для этой роли",
      loadError: "Не удалось загрузить права",
      saveError: "Не удалось сохранить права",
      expand: "Раскрыть",
      collapse: "Свернуть",
    },
    associations: {
      loadError: "Не удалось загрузить данные",
      saveError: "Не удалось сохранить",
      deleteError: "Не удалось удалить",
      noSelection: "Выберите узел в дереве",
      rootSelector: "Вид группы",
      rootSelectorPlaceholder: "Выберите вид",
      groupKinds: {
        add: "Добавить вид",
        colName: "Название",
        colCode: "Код",
        colOrder: "Порядок",
        colIcon: "Иконка",
        colActions: "Действия",
        empty: "Виды групп ещё не созданы",
        createTitle: "Новый вид группы",
        editTitle: "Редактирование вида",
        code: "Код (lowercase)",
        codeHint: "Латиница, цифры, дефис. Например: union, community-local.",
        codeInvalid: "Только lowercase латиница, цифры и дефис, до 64 символов.",
        codeTaken: "Код уже занят другим видом группы.",
        name: "Название",
        order: "Порядок",
        iconUrl: "URL иконки",
        deleteTitle: "Удалить вид группы?",
        deleteMessage:
          "Вид «{{name}}» будет удалён. Убедитесь, что к нему не привязаны группы.",
        deleteInUse:
          "Нельзя удалить: к этому виду привязаны группы. Сначала перенесите или удалите группы.",
      },
      tree: {
        addRoot: "Новая корневая группа",
        addSubgroup: "Новая подгруппа",
        rename: "Редактировать",
        move: "Перенести",
        remove: "Удалить",
        empty: "Для выбранного вида групп нет узлов",
        inactive: "Неактивна",
        autoAccept: "Авто-приём",
        noSelfServiceJoin: "Без самостоятельного вступления",
        moderators: "Модераторов: {{count}}",
        deleteTitle: "Удалить группу?",
        deleteMessage: "Группа «{{name}}» будет удалена. Это действие нельзя отменить.",
        hasChildren: "В группе есть дочерние узлы. Удалите или перенесите их.",
        hasMembers: "В группе есть участники. Действие запрещено.",
        moveTitle: "Перенос группы",
        moveMessage: "Выберите нового родителя (того же вида группы).",
        makeRoot: "Сделать корневой",
        moveSubmit: "Перенести",
        moveInvalid: "Новый родитель должен быть того же вида и не быть потомком.",
        createRootTitle: "Создание корневой группы",
        createSubgroupTitle: "Создание подгруппы",
        editTitle: "Редактирование группы",
        name: "Название",
        order: "Порядок",
        description: "Описание",
        iconUrl: "URL иконки",
        externalUrl: "Внешняя ссылка",
        requiresApproval: "Требуется подтверждение заявок",
        requiresApprovalHint:
          "Если выключено, заявки будут авто-подтверждаться при отправке.",
        isActive: "Группа активна",
        isActiveHint:
          "Если выключено, вступать в группу нельзя, но существующие членства сохраняются.",
        allowModeratorSubgroups: "Модераторы могут создавать подгруппы",
        allowModeratorSubgroupsHint:
          "Переключается только администратором ассоциаций.",
        allowsUserMembership: "Разрешено вступление пользователей",
        allowsUserMembershipHint:
          "Если выключено, пользователи не смогут подать заявку на членство в этой группе.",
        save: "Сохранить",
        create: "Создать",
        cancel: "Отмена",
      },
      moderators: {
        title: "Модераторы",
        colUser: "Пользователь",
        colEmail: "E-mail",
        colActions: "Действия",
        empty: "Модераторов нет",
        addTitle: "Назначить модератора",
        addSubmit: "Назначить",
        searchPlaceholder: "Поиск по имени или email…",
        remove: "Снять",
        removeTitle: "Снять модератора?",
        removeMessage: "Пользователь {{name}} больше не будет модерировать ветку.",
        alreadyAssigned: "Этот пользователь уже назначен модератором.",
        cannotRemoveLastRoot:
          "Нельзя снять последнего модератора корня без права «Управление ассоциациями».",
        notModerator: "Действие запрещено вне вашего поддерева.",
      },
      specializations: {
        title: "Специализации индустрии",
        subtitle: "Доступно только для корневой группы (индустрии).",
        add: "Добавить специализацию",
        empty: "Специализаций пока нет",
        name: "Название",
        order: "Порядок",
        save: "Сохранить",
        cancel: "Отмена",
        deleteTitle: "Удалить специализацию?",
        deleteMessage: "Специализация «{{name}}» будет удалена.",
        industryMismatch:
          "Специализация должна принадлежать той же индустрии, что и выбранный узел.",
      },
      unverified: {
        colUser: "Пользователь",
        colGroup: "Путь",
        colSpecialization: "Специализация",
        colSubmittedOn: "Дата подачи",
        colActions: "Действия",
        verify: "Подтвердить",
        reject: "Отклонить",
        empty: "Новых заявок нет",
        loadError: "Не удалось загрузить список заявок",
        noAccess: "Нет прав на просмотр очереди.",
        alreadyApproved: "Заявка уже подтверждена.",
        notModerator: "Вы не модератор этого поддерева.",
        membershipNotAllowed:
          "Для этой группы отключено вступление пользователей — подтверждение невозможно.",
        rejectTitle: "Отклонить заявку",
        rejectLead: "Заявка перейдёт в статус «Отклонена». Укажите причину — её увидит заявитель.",
        rejectReasonLabel: "Причина отклонения",
        rejectReasonPlaceholder: "Кратко опишите причину…",
        rejectReasonRequired: "Укажите причину отклонения.",
        rejectReasonMax: "Не более 1024 символов.",
        rejectError: "Не удалось отклонить заявку.",
      },
    },
  },
}
